module.exports = __webpack_public_path__ + "static/slider_1a-4d4ca994a752394849bf45900b2067ce.jpg";